import * as c from './actions/config';
import * as colors from './actions/colors';
import * as dominoes from './actions/dominoes';
import * as groupes from './actions/groupes';
import * as settings from './actions/settings';
import * as session from './actions/session';

export const Config = c;
export const Colors = colors;
export const Dominoes = dominoes;
export const Groupes = groupes;
export const Settings = settings;
export const Session = session;
